import React, { useState, useEffect } from 'react';
import { DialogContent, DialogProps, Input, Body } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

import { EnhancedDialog, ModalActionButtons, utils } from 'shared';

interface AddToCessionModalProps extends DialogProps {
  title: string;
  message: string;
  closeModal: () => void;
  onConfirmAction: (cessionNumber: string) => Promise<any>;
}

export const AddToCessionModal: React.FunctionComponent<AddToCessionModalProps> = ({
  title,
  message,
  closeModal,
  open,
  onConfirmAction
}) => {
  /**
   * State
   */
  const [cessionNumber, setCessionNumber] = useState('');

  useEffect(() => {
    setCessionNumber('');
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const onCessionNumberChange = (e: React.ChangeEvent<any>) => {
    setCessionNumber(e.target.value);
  };

  const handleSave = () => {
    return onConfirmAction(cessionNumber);
  };

  return (
    <EnhancedDialog open={open} onClose={closeModal} title={title} dialogMaxWidth="480px">
      <DialogContent>
        <div className="flex align-content-center">
          <Body>{utils.text.firstLetterUppercase(message)}</Body>
        </div>
        <div style={{ marginTop: 30 }}>
          <Input
            label={utils.text.firstLetterUppercase(i18next.t('cessionNumber'))}
            onChange={onCessionNumberChange}
            value={!cessionNumber || isNaN(Number(cessionNumber)) ? '' : String(parseInt(cessionNumber))}
          />
        </div>
      </DialogContent>
      <ModalActionButtons closeModal={closeModal} save={handleSave} changeButtonName={i18next.t('save')} />
    </EnhancedDialog>
  );
};
